import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SET_REPORT_REQUEST_KEY } from 'components/Pages/Reports/actions.js';
import Box from '@bit/knotchinc.web-react-components.box';
import { StepContainer, Title, RadioItem, RadioItemTitle, RadioItemDesc } from './styled.js';

class ContentTypeStep extends Component {
  constructor(props) {
    super(props);
    const currentContentTypes = [];
    if (props.contentType) {
      if (props.contentType === 'all') {
        currentContentTypes.push(['paid', 'owned']);
      } else {
        currentContentTypes.push(props.contentType);
      }
    }

    this.state = {
      contentTypes: currentContentTypes,
    };
  }

  toggleValue(value) {
    const { setValue, setValid } = this.props;
    const { contentTypes } = this.state;
    const newContentTypes = [...contentTypes];
    if (contentTypes.includes(value)) {
      newContentTypes.splice(contentTypes.indexOf(value), 1);
    } else {
      newContentTypes.push(value);
    }

    if (newContentTypes.length === 2) {
      setValue('all');
      setValid(true);
    } else if (newContentTypes.length === 1) {
      setValue(newContentTypes[0]);
      setValid(true);
    } else if (newContentTypes.length === 0) {
      setValue(null);
      setValid(false);
    }

    this.setState({ contentTypes: newContentTypes });
  }

  render() {
    const { contentTypes } = this.state;

    return (
      <StepContainer>
        <Title>What type of content do you want?</Title>
        <Box mt="48px">
          <RadioItem onClick={() => this.toggleValue('paid')} selected={contentTypes.includes('paid')}>
            <RadioItemTitle>PAID CONTENT</RadioItemTitle>
            <RadioItemDesc>
              This is your content partnered on publishers’ platforms.
            </RadioItemDesc>
          </RadioItem>
          <RadioItem onClick={() => this.toggleValue('owned')} selected={contentTypes.includes('owned')}>
            <RadioItemTitle>OWNED CONTENT</RadioItemTitle>
            <RadioItemDesc>
              This is your content on your own platform.
            </RadioItemDesc>
          </RadioItem>
        </Box>
      </StepContainer>
    );
  }
}

ContentTypeStep.defaultProps = {
  name: 'Content Type',
};


function mapStateToProps({ ReportRequest: {
  request: { content_type },
 } }) {
  return {
    contentType: content_type,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setValue: (value) => dispatch({ type: SET_REPORT_REQUEST_KEY, payload: { content_type: value } }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentTypeStep);

